import React from 'react'

export default function Interests() {
    return (
        <div className="container-fluid">
        <section id="interest">
          <main className="offset-md-2 my-3 px-3 pt-3">
          <div className="container py-4">
            <h1 className="title">
              Interests
            </h1>
            <p>I enjoy most of my time being outdoors to participate in different activities with friends including martial arts, expoloring cities as well as volunteering at a local animal shelter.</p>
            <p>When indoors, I follow a number of comedy, sci-fi and fantasy genre movies and television shows. I am also an aspiring chef, and I spend a large amount of my free time exploring the latest technology advancements in the fullstack web development world.</p>
            </div>
            </main>
            </section>
            </div>
    )
}
